export default __webpack_public_path__ + "static/media/Education.c7cbc0dc.png";